module.exports = __webpack_public_path__ + "img/campus-small-5.9a93449d.jpg";